/**
 * Lightweight client↔server clock synchronisation (NTP-lite).
 *
 * Computes a one-shot offset so `serverNow()` returns a timestamp
 * aligned with the server clock.  Accuracy: ±RTT/2 (typically <100 ms).
 *
 * Used by the auction countdown timer to compensate for client clock skew.
 */

let offsetMs = 0

export async function syncClock(): Promise<void> {
  const t0 = Date.now()
  const res = await fetch("/api/time", { cache: "no-store" })
  if (!res.ok) return
  const t1 = Date.now()
  const { now } = await res.json()
  const serverTime = new Date(now as string).getTime()
  if (!Number.isFinite(serverTime)) return
  const rtt = t1 - t0
  offsetMs = serverTime - (t0 + rtt / 2)
}

/** Returns `Date.now()` corrected by the server-time offset. */
export function serverNow(): number {
  return Date.now() + offsetMs
}
